import type { LandingPageTemplateProps } from "../components/landing-page-template";
import logo from "../assets/logos/heroi.webp";

const config: LandingPageTemplateProps = {
  logo,
  gradient: "bg-gradient-to-b from-black/60 to-blue-900/60",
  header: "🎯 MELHORES PROMOÇÕES E CUPONS DIRETO NO SEU WHATSAPP",
  vip: ["🚨 GRUPO VIP 🚨", "100% GRATUITO"],
  discount: "OFERTAS com 50% 60% 70% OFF 🦸🏻‍♂️",
  waText: "GRUPO WHATSAPP",
  waHref: "https://linktr.it/heroi",
  tgText: "CANAL TELEGRAM",
  tgHref: "https://t.me/heroidapromo",
  members: "⚡️ JÁ SOMOS +200 MIL MEMBROS ⚡️",
  footer: "Direitos Reservados",
};

export default config;
